// axios配置  可自行根据项目进行更改，只需更改该文件即可，其他文件可以不动
// The axios configuration can be changed according to the project, just change the file, other files can be left unchanged

import type { AxiosResponse } from 'axios';
import { clone } from 'lodash-es';
import type { RequestOptions, Result } from '/#/axios';
import type { AxiosTransform, CreateAxiosOptions } from './axiosTransform';
import { VAxios } from './Axios';
import { checkStatus } from './checkStatus';
import { useGlobSetting } from '/@/hooks/setting';
import { useMessage } from '/@/hooks/web/useMessage';
import { ContentTypeEnum, RequestEnum, ResultEnum } from '/@/enums/httpEnum';
import { isString } from '/@/utils/is';
import { deepMerge, setObjToUrlParams } from '/@/utils';
import { useErrorLogStoreWithOut } from '/@/store/modules/errorLog';
import { useI18n } from '/@/hooks/web/useI18n';
import { formatRequestDate, joinTimestamp } from './helper';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { getUrlToDsahboard } from '/@/hooks/web/usePage';
import { useLockStore } from '/@/store/modules/lock';
import { isSmallScreen } from '/@/hooks/event/useBreakpoint';
import axios, { CancelTokenSource } from 'axios';
import { useLoginState } from '/@/views/sys/login/useLogin';
import { buildUUID } from '../../uuid';
import { showToast, showDialog, showLoadingToast } from 'vant';

import { router } from '/@/router';

import { useDialog } from '/@/components/Dialog/useDialog';
const dialog = useDialog();
const globSetting = useGlobSetting();
const urlPrefix = globSetting.urlPrefix;
const { createMessage, createErrorModal } = useMessage();

function errorTipsFun(msg) {
  if (isSmallScreen()) {
    showToast({ message: msg, duration: 3000, forbidClick: false });
  } else {
    createMessage.error(msg);
  }
}
const pendingRequests: Map<string, CancelTokenSource> = new Map();
/**
 * @description: 数据处理，方便区分多种处理方式
 */
const transform: AxiosTransform = {
  /**
   * @description: 处理请求数据。如果数据不是预期格式，可直接抛出错误
   */
  transformRequestHook: (res: AxiosResponse<Result>, options: RequestOptions) => {
    const { t } = useI18n();
    const { isTransformResponse, isReturnNativeResponse } = options;
    // 是否返回原生响应头 比如：需要获取响应头时使用该属性
    if (isReturnNativeResponse) {
      return res;
    }
    // 不进行任何处理，直接返回
    // 用于页面代码可能需要直接获取code，data，message这些信息时开启
    if (!isTransformResponse) {
      return res.data;
    }
    // 错误的时候返回

    const { data } = res;
    if (!data) {
      // return '[HTTP] Request has no return value';
      throw new Error(t('sys.api.apiRequestFailed'));
    }
    //  这里 code，result，message为 后台统一的字段，需要在 types.ts内修改为项目自己的接口返回格式
    const { status, message, error, data: dataStr } = data;
    const hasSuccess = status === ResultEnum.SUCCESS;
    if (hasSuccess) {
      /**
       * 唐鑫
       * 目前由于服务端返回的数据分页对象与前端框架的不一致，需要二次转义
       * 目前的做法是兼容了MOCK前端数据结构和服务端API数据结构同时使用的场景
       * 服务端调整后，需要同步修改，return data.data;
       * */
      if (data.data && data.data.totalRecords) {
        return {
          ...data.data,
          total: data.data.totalRecords,
        };
      }
      return data.data;
    }

    /**
     * 服务端返回状态码表
     * 200：请求成功
     * 301：微信未授权
     * 302：未绑定用户信息
     * 303：未设置隐私密码
     * 304：未验证隐私密码
     * 305：安全会话已过期
     * 400：请求错误，请修正请求
     * 401：没有被授权或者授权已经失效
     * 403：请求被理解，但是拒绝执行
     * 404：资源未找到
     * 405：请求方法不允许被执行
     * 408：请求超时
     * 429：请求过多
     * 500：服务器内部错误
     * 502：响应无效
     * 504：上游服务器超时
     * 703：未认证
     *
     * 针对以上情况，只有401需要根据ERROR对象做进一步处理，其他的错误提示即可。
     */
    // let setremeberurl = /.*((login)|(verification)|(verification\/set)).*?/;
    let setremeberurl = /(\/login|\/verification|\/verification\/set)(\/|$|\?|#)/;

    let url = window.location.href;
    const errTips = message || error?.msg || error?.code || t('sys.api.apiRequestFailed');
    if (status == ResultEnum.ERROR_201) {
      showToast({
        message: errTips,
        forbidClick: true,
        duration: 4000,
      });
      setTimeout(() => {
        router.replace({ name: 'homeIndex' });
      }, 4000);
    } else if (status == ResultEnum.ERROR_301) {
      dialog.confirm({
        content: '即将自动跳转授权',
        onConfirm: () => {},
        duration: 1600,
      });
      if (!setremeberurl.test(url)) {
        sessionStorage.setItem('remeberurl', url);
      }
      localStorage.removeItem('new-wx-openId');
      setTimeout(() => {
        if (url.indexOf('verification') > -1) {
          //   router.replace({ path: '/verification' });
          window.location.reload();
        } else {
          router.push({ path: '/verification' });
        }
      }, 1500);
    } else if (status == ResultEnum.ERROR_302) {
      dialog.confirm({
        content: '即将自动跳转登录页面',
        onConfirm: () => {},
        duration: 1600,
      });
      //   sessionStorage.clear();
      //   localStorage.clear();
      if (!setremeberurl.test(url)) {
        sessionStorage.setItem('remeberurl', url);
      }
      setTimeout(() => {
        router.push({ path: '/login' });
      }, 1500);
    } else if (status == ResultEnum.ERROR_303) {
      dialog.confirm({
        content: '即将自动跳转设置隐私密码页面',
        onConfirm: () => {},
        duration: 1600,
      });
      if (!setremeberurl.test(url)) {
        sessionStorage.setItem('remeberurl', url);
      }
      setTimeout(() => {
        router.push({ path: '/verification/set' });
      }, 1500);
    } else if (status == ResultEnum.ERROR_304) {
      if (!setremeberurl.test(url)) {
        sessionStorage.setItem('remeberurl', url);
      }

      dialog.confirm({
        content: '即将自动跳转验证隐私密码页面',
        onConfirm: () => {},
        duration: 1600,
      });
      setTimeout(() => {
        router.push({ path: '/verification' });
      }, 1500);
      //   return;
    } else if (status == ResultEnum.ERROR_305) {
      if (!setremeberurl.test(url)) {
        sessionStorage.setItem('remeberurl', url);
      }

      dialog.confirm({
        content: '即将自动跳转重新验证隐私密码页面',
        onConfirm: () => {},
        duration: 1600,
      });
      setTimeout(() => {
        router.push({ path: '/verification' });
      }, 1500);
    } else if (status == ResultEnum.ERROR_401) {
      /**
       * -1: 系统繁忙，请稍候再试(默认)
       * 0: 成功
       * 1: 业务逻辑错误
       * 2: 系统内部系统错误
       * 3: 调用上游系统出现错误
       * 4: 请求参数错误
       * 5: 用户未登录或信息过期
       * 6: 数据库访问错误
       * 7: 中间件错误
       * 11: 应用系统信息验证失败
       * 13: 权限不足（用户权限不足）
       * 14：客户权限不足
       * 16: 文件(流)访问错误
       * 17: 文件大小超过限制
       * 18: 请求资源不存在
       */
      //   授权失败后需要重新授权

      const userStore = useUserStoreWithOut();
      switch (error?.code) {
        // 重新登录
        case '5':
          userStore.setToken(undefined);
          // userStore.logout(true, dataStr);
          userStore.setSessionTimeout(false);
          userStore.setUserInfo(null);
          useLoginState().setLoginState(0);
          cancelAllPendingRequests();
          // window.location.href = redirectWithReturnAddress(dataStr);

          window.location.href = dataStr;
          throw new Error(errTips);

          break;
        case '13':
          // 权限不足 - 跳到登陆页
          // notification.warning({
          //   message: '提示',
          //   description: errTips,
          //   duration: 10,
          // });
          // setTimeout(()=>{
          //   userStore.setToken(undefined);
          //   userStore.logout(true, dataStr);
          //   throw new Error(errTips);
          // },5000)

          // getUrlToDsahboard(`/dashboard/power?url=${url}`);
          break;
        case '14':
          // 跳转VIP页面
          break;
        case '20':
          // 跳转到应用开通页面
          // getUrlToDsahboard(`/dashboard/application?url=${url}`);
          break;
      }
    }

    //业务异常 status==400 && data中的code==22
    else if (status == ResultEnum.ERROR_400 && error?.code == '22') {
      switch (error?.type) {
        case '1':
          //企业未认证
          getUrlToDsahboard(`/dashboard/authentication?url=${url}`);
          break;
        case '2':
          // 合同未签署
          getUrlToDsahboard(`/dashboard/contractSigning?url=${url}`);
          break;
        case '3':
          //积分不足，去充值-在线充值
          getUrlToDsahboard(`/dashboard/onlineRecharge?url=${url}`);
          break;
      }
    }

    //系统异常类 ，文字提示前端统一文字
    /**
     * 403： 系统异常 code=-1
     * 500  数据库异常 code=6
     *
     */
    else if (status == ResultEnum.ERROR_403) {
      switch (error?.code) {
        case '-1':
          // notification.error({
          //     message: '提示',
          //     description: '出错了，请稍后再试～',
          //     duration: 10,
          // });
          errorTipsFun('出错了，请稍后再试～');
          throw new Error(errTips);
          break;
      }
    } else if (status == ResultEnum.ERROR_500) {
      switch (error?.code) {
        case '6':
          // notification.error({
          //     message: '提示',
          //     description: '出错了，请稍后再试～',
          //     duration: 10,
          // });
          errorTipsFun('出错了，请稍后再试～');
          throw new Error(errTips);
          break;
      }
    } else if (status == ResultEnum.ERROR_504) {
      switch (error?.code) {
        case '3':
          // notification.error({
          //     message: '提示',
          //     description: '出错了，请稍后再试～',
          //     duration: 10,
          // });
          errorTipsFun('出错了，请稍后再试～');
          throw new Error(errTips);
          break;
      }
    } else if (status == ResultEnum.ERROR_701) {
      //   showToast(errTips);
      //   showDialog({
      //     title: '温馨提示',
      //     message: errTips,
      //   }).then(() => {
      //     // on close
      //     window.history.go(-1);
      //   });
      dialog.confirm({
        content: errTips,
        showFooter: true,
        duration: 0,
        onConfirm: () => {
          router.replace({ path: '/home' });
        },
      });
    } else if (status == ResultEnum.ERROR_703) {
      //   showDialog({
      //     title: '温馨提示',
      //     message: '此功能需要您身份证认证后才可以使用，请您先完成身份证认证。',
      //   }).then(() => {
      //     // on close

      //     router.push({ path: '/auth' });
      //   });
      dialog.confirm({
        content: '此功能需要您身份证认证后才可以使用，请您先完成身份证认证。',
        showFooter: true,
        duration: 0,
        onConfirm: () => {
          router.push({ path: '/userAuth' });
        },
      });

      // notification.error({
      //     message: '提示',
    }

    // 其他都以错误提示即可
    // notification.error({
    //     message: '提示',
    //     description: errTips,
    //     duration: 10
    // });
    else {
      errorTipsFun(errTips);
    }

    throw new Error(errTips);
  },

  // 请求之前处理config
  beforeRequestHook: (config, options) => {
    const { apiUrl, joinPrefix, joinParamsToUrl, formatDate, joinTime = true, urlPrefix } = options;

    if (joinPrefix) {
      config.url = `${urlPrefix}${config.url}`;
    }
    if (apiUrl && isString(apiUrl)) {
      config.url = `${apiUrl}${config.url}`;
    }

    // 20250213 fix formapi请求一次问题
    config['random'] = buildUUID();
    const params = config.params || {};
    const data = config.data || false;
    formatDate && data && !isString(data) && formatRequestDate(data);
    if (config.method?.toUpperCase() === RequestEnum.GET) {
      if (!isString(params)) {
        // 给 get 请求加上时间戳参数，避免从缓存中拿数据。
        config.params = Object.assign(params || {}, joinTimestamp(joinTime, false));
      } else {
        // 兼容restful风格
        config.url = config.url + params + `${joinTimestamp(joinTime, true)}`;
        config.params = undefined;
      }
    } else {
      if (!isString(params)) {
        formatDate && formatRequestDate(params);
        config.params = Object.assign(params || {}, joinTimestamp(joinTime, false));
        if (Reflect.has(config, 'data') && config.data && Object.keys(config.data).length > 0) {
          config.data = data;
          config.params = params;
        } else {
          // 非GET请求如果没有提供data，则将params视为data
          config.data = params;
          config.params = undefined;
        }
        if (joinParamsToUrl) {
          config.url = setObjToUrlParams(
            config.url as string,
            Object.assign({}, config.params, config.data),
          );
        }
      } else {
        // 兼容restful风格
        config.url = config.url + params;
        config.params = undefined;
      }
    }
    const lockStore = useLockStore();
    lockStore.resetLockInfo();
    return config;
  },

  /**
   * @description: 请求拦截器处理
   */
  // requestInterceptors: (config, options) => {
  requestInterceptors: (config, _) => {
    const key = generateKey(config);
    if (pendingRequests.has(key)) {
      pendingRequests.get(key)?.cancel(`Duplicate request cancelled`);
    }
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;
    pendingRequests.set(key, source);

    // 请求之前处理config
    const lockStore = useLockStore();
    lockStore.resetLockInfo();
    return config;
  },

  /**
   * @description: 响应拦截器处理
   */
  responseInterceptors: (res: AxiosResponse<any>) => {
    const key = generateKey(res.config);
    pendingRequests.delete(key);
    return res;
  },

  /**
   * @description: 响应错误处理
   */
  responseInterceptorsCatch: (error: any) => {
    const { t } = useI18n();
    const errorLogStore = useErrorLogStoreWithOut();
    errorLogStore.addAjaxErrorInfo(error);
    const { response, code, message, config } = error || {};
    const errorMessageMode = config?.requestOptions?.errorMessageMode || 'none';
    const msg: string = response?.data?.error?.msg ?? '';
    const err: string = error?.toString?.() ?? '';
    let errMessage = '';
    if (error.config) {
      const key = generateKey(error.config);
      pendingRequests.delete(key);
    }
    try {
      if (code === 'ECONNABORTED' && message.indexOf('timeout') !== -1) {
        errMessage = t('sys.api.apiTimeoutMessage');
      }
      if (err?.includes('Network Error')) {
        errMessage = t('sys.api.networkExceptionMsg');
      }
      console.log('error....', error);
      if (errMessage) {
        if (errorMessageMode === 'modal') {
          createErrorModal({ title: t('sys.api.errorTip'), content: errMessage });
        } else if (errorMessageMode === 'message') {
          errorTipsFun(errMessage);
        }
        return Promise.reject(error);
      }
    } catch (error) {
      throw new Error(error as unknown as string);
    }

    checkStatus(error?.response?.status, msg, errorMessageMode, '');
    return Promise.reject(error);
  },
};

function generateKey(config: any): string {
  //const _t = config.params?._t ? config.params?._t : config.data?._t ? config.data?._t : '';
  return [config.method, config.url, config.random].join('-');
}

const cancelAllPendingRequests = () => {
  pendingRequests.forEach((item) => {
    item.cancel(`All requests are cancelled`);
  });
  pendingRequests.clear();
};

function createAxios(opt?: Partial<CreateAxiosOptions>) {
  return new VAxios(
    deepMerge(
      {
        // See https://developer.mozilla.org/en-US/docs/Web/HTTP/Authentication#authentication_schemes
        // authentication schemes，e.g: Bearer
        // authenticationScheme: 'Bearer',
        authenticationScheme: '',
        timeout: 60 * 1000,
        // 基础接口地址
        // baseURL: globSetting.apiUrl,

        headers: { 'Content-Type': ContentTypeEnum.JSON },
        // 如果是form-data格式
        // headers: { 'Content-Type': ContentTypeEnum.FORM_URLENCODED },
        // 数据处理方式
        transform: clone(transform),
        // 配置项，下面的选项都可以在独立的接口请求中覆盖
        requestOptions: {
          // 默认将prefix 添加到url
          joinPrefix: true,
          // 是否返回原生响应头 比如：需要获取响应头时使用该属性
          isReturnNativeResponse: false,
          // 需要对返回数据进行处理
          isTransformResponse: true,
          // post请求的时候添加参数到url
          joinParamsToUrl: false,
          // 格式化提交参数时间
          formatDate: true,
          // 消息提示类型
          errorMessageMode: 'message',
          // 接口地址
          apiUrl: globSetting.apiUrl,
          // 接口拼接地址
          urlPrefix: urlPrefix,
          //  是否加入时间戳
          joinTime: true,
          // 忽略重复请求
          ignoreCancelToken: true,
          // 是否携带token
          withToken: true,
        },
      },
      opt || {},
    ),
  );
}

function createAxios2(opt?: Partial<CreateAxiosOptions>) {
  return new VAxios(
    deepMerge(
      {
        // See https://developer.mozilla.org/en-US/docs/Web/HTTP/Authentication#authentication_schemes
        // authentication schemes，e.g: Bearer
        // authenticationScheme: 'Bearer',
        authenticationScheme: '',
        timeout: 60 * 1000,
        // 基础接口地址
        // baseURL: globSetting.apiUrl,

        headers: { 'Content-Type': ContentTypeEnum.FORM_URLENCODED },
        // 如果是form-data格式 JSON
        // headers: { 'Content-Type': ContentTypeEnum.FORM_URLENCODED },
        // 数据处理方式
        transform: clone(transform),
        // 配置项，下面的选项都可以在独立的接口请求中覆盖
        requestOptions: {
          // 默认将prefix 添加到url
          joinPrefix: true,
          // 是否返回原生响应头 比如：需要获取响应头时使用该属性
          isReturnNativeResponse: false,
          // 需要对返回数据进行处理
          isTransformResponse: true,
          // post请求的时候添加参数到url
          joinParamsToUrl: false,
          // 格式化提交参数时间
          formatDate: true,
          // 消息提示类型
          errorMessageMode: 'message',
          // 接口地址
          apiUrl: globSetting.apiUrl,
          // 接口拼接地址
          urlPrefix: urlPrefix,
          //  是否加入时间戳
          joinTime: true,
          // 忽略重复请求
          ignoreCancelToken: true,
          // 是否携带token
          withToken: true,
        },
      },
      opt || {},
    ),
  );
}

function createAxios3(opt?: Partial<CreateAxiosOptions>) {
  return new VAxios(
    deepMerge(
      {
        // See https://developer.mozilla.org/en-US/docs/Web/HTTP/Authentication#authentication_schemes
        // authentication schemes，e.g: Bearer
        // authenticationScheme: 'Bearer',
        authenticationScheme: 'Bearer ',
        timeout: 60 * 1000,
        // 基础接口地址
        // baseURL: globSetting.apiUrl,

        headers: { 'Content-Type': ContentTypeEnum.FORM_DATA },
        // 如果是form-data格式 JSON
        // headers: { 'Content-Type': ContentTypeEnum.FORM_URLENCODED },
        // 数据处理方式
        transform: clone(transform),
        // 配置项，下面的选项都可以在独立的接口请求中覆盖
        requestOptions: {
          // 默认将prefix 添加到url
          joinPrefix: true,
          // 是否返回原生响应头 比如：需要获取响应头时使用该属性
          isReturnNativeResponse: false,
          // 需要对返回数据进行处理
          isTransformResponse: true,
          // post请求的时候添加参数到url
          joinParamsToUrl: false,
          // 格式化提交参数时间
          formatDate: true,
          // 消息提示类型
          errorMessageMode: 'message',
          // 接口地址
          apiUrl: globSetting.apiUrl,
          // 接口拼接地址
          urlPrefix: urlPrefix,
          //  是否加入时间戳
          joinTime: true,
          // 忽略重复请求
          ignoreCancelToken: true,
          // 是否携带token
          withToken: true,
        },
      },
      opt || {},
    ),
  );
}

export const defHttp = createAxios({
  requestOptions: {
    apiUrl: '/api',
  },
});

export const otherHttp = createAxios2({
  requestOptions: {
    apiUrl: '/api',
  },
});

export const uploadHttp = createAxios3({
  requestOptions: {
    apiUrl: '/api',
  },
});

export const apiHttp = createAxios2({
  requestOptions: {
    apiUrl: '/api',
  },
});

export const apiHttp2 = createAxios2({
  timeout: 60 * 1000 * 5,
  requestOptions: {
    apiUrl: '/api',
  },
});
